module.exports = __webpack_public_path__ + "img/person-3.caf6a55a.jpg";